import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-28" }
const _hoisted_2 = { class: "mx-auto max-w-4xl" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "text-gray-900 text-4xl font-medium flex items-center gap-2" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_9 = {
  key: 2,
  class: "grid gap-4"
}
const _hoisted_10 = { class: "flex flex-col gap-4 md:flex-row md:items-start md:justify-between" }
const _hoisted_11 = { class: "flex items-start gap-4" }
const _hoisted_12 = { class: "flex h-12 w-12 items-center justify-center rounded-full bg-[#f6f1ec] text-sm font-semibold text-gray-700" }
const _hoisted_13 = { class: "text-gray-900 font-semibold" }
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_15 = { class: "flex flex-wrap items-center gap-4 text-sm text-gray-600" }
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_18 = {
  key: 1,
  class: "text-sm text-gray-600"
}
const _hoisted_19 = {
  key: 2,
  class: "mt-2 flex items-center gap-2"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "flex flex-wrap items-center gap-3 md:flex-col md:items-end" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex items-center gap-2" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "mt-3 text-xs text-gray-500" }
const _hoisted_28 = { class: "mx-auto max-w-4xl mt-12" }
const _hoisted_29 = { class: "mb-6" }
const _hoisted_30 = { class: "text-gray-900 text-3xl font-medium flex items-center gap-2" }
const _hoisted_31 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_32 = {
  key: 1,
  class: "grid gap-4"
}
const _hoisted_33 = { class: "flex flex-col gap-4 md:flex-row md:items-start md:justify-between" }
const _hoisted_34 = { class: "flex items-start gap-4" }
const _hoisted_35 = { class: "flex h-12 w-12 items-center justify-center rounded-full bg-[#f6f1ec] text-sm font-semibold text-gray-700" }
const _hoisted_36 = { class: "text-gray-900 font-semibold" }
const _hoisted_37 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_38 = { class: "flex flex-wrap items-center gap-4 text-sm text-gray-600" }
const _hoisted_39 = { class: "flex items-center gap-2" }
const _hoisted_40 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_41 = {
  key: 1,
  class: "text-sm text-gray-600"
}
const _hoisted_42 = {
  key: 2,
  class: "mt-2 flex items-center gap-2"
}
const _hoisted_43 = ["href"]
const _hoisted_44 = ["href"]
const _hoisted_45 = { class: "flex flex-wrap items-center gap-3 md:flex-col md:items-end" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "flex items-center gap-2" }
const _hoisted_48 = ["href"]
const _hoisted_49 = ["href"]
const _hoisted_50 = { class: "mt-3 text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UsersIcon = _resolveComponent("UsersIcon")!
  const _component_MagnifyingGlassIcon = _resolveComponent("MagnifyingGlassIcon")!
  const _component_EnvelopeIcon = _resolveComponent("EnvelopeIcon")!
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!
  const _component_UserPlusIcon = _resolveComponent("UserPlusIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_UserGroupIcon = _resolveComponent("UserGroupIcon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _createVNode(_component_UsersIcon, { class: "h-7 w-7 text-primary" }),
          _cache[1] || (_cache[1] = _createTextVNode(" Member Directory "))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-gray-600 mt-2" }, " Find members in the network and reach out directly. ", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          class: "block text-sm font-medium text-gray-700 mb-2",
          for: "member-search"
        }, " Search members ", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_MagnifyingGlassIcon, { class: "absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" }),
          _withDirectives(_createElementVNode("input", {
            id: "member-search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            class: "block w-full rounded-full border border-gray-300 bg-white py-2.5 pl-10 pr-4 text-sm text-gray-900 focus:border-primary focus:ring-primary",
            placeholder: "Search by name or email",
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.searchQuery]
          ])
        ])
      ]),
      (_ctx.loadingUsers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Loading members... "))
        : (_ctx.filteredUsers.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No members found. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: user._id,
                  class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-5"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getInitials(user.fullName || user.email)), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(user.fullName || 'Member'), 1),
                        (user.company)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(user.company), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_EnvelopeIcon, { class: "h-4 w-4 text-gray-400" }),
                            _createTextVNode(" " + _toDisplayString(user.email), 1)
                          ]),
                          (user.phoneNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_component_PhoneIcon, { class: "h-4 w-4 text-gray-400" }),
                                _createTextVNode(" " + _toDisplayString(user.phoneNumber), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.formatAddress(user))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.formatAddress(user)), 1))
                          : _createCommentVNode("", true),
                        (user.linkedinUrl || user.xUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              (user.linkedinUrl)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "inline-flex items-center rounded-full bg-gray-100 p-2 text-gray-700 hover:bg-gray-200",
                                    href: user.linkedinUrl,
                                    rel: "noreferrer",
                                    target: "_blank"
                                  }, _cache[4] || (_cache[4] = [
                                    _createElementVNode("svg", {
                                      "aria-hidden": "true",
                                      class: "h-4 w-4",
                                      viewBox: "0 0 24 24"
                                    }, [
                                      _createElementVNode("path", {
                                        fill: "currentColor",
                                        d: "M19.99 3H4.01C3.45 3 3 3.45 3 4.01v15.98C3 20.55 3.45 21 4.01 21h15.98c.56 0 1.01-.45 1.01-1.01V4.01C21 3.45 20.55 3 19.99 3zM8.34 18.34H5.67V9.75h2.67v8.59zM7 8.58a1.55 1.55 0 1 1 0-3.1 1.55 1.55 0 0 1 0 3.1zm11.34 9.76h-2.66v-4.18c0-.99-.02-2.27-1.38-2.27-1.38 0-1.59 1.08-1.59 2.2v4.25H10.05V9.75h2.55v1.17h.04c.35-.66 1.2-1.36 2.47-1.36 2.64 0 3.13 1.74 3.13 4.01v4.77z"
                                      })
                                    ], -1)
                                  ]), 8, _hoisted_20))
                                : _createCommentVNode("", true),
                              (user.xUrl)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "inline-flex items-center rounded-full bg-gray-100 p-2 text-gray-700 hover:bg-gray-200",
                                    href: user.xUrl,
                                    rel: "noreferrer",
                                    target: "_blank"
                                  }, _cache[5] || (_cache[5] = [
                                    _createElementVNode("svg", {
                                      "aria-hidden": "true",
                                      class: "h-4 w-4",
                                      viewBox: "0 0 24 24"
                                    }, [
                                      _createElementVNode("path", {
                                        fill: "currentColor",
                                        d: "M18.9 2h3.3l-7.2 8.2L23.4 22h-6.8l-5.3-7-6.1 7H1.9l7.7-8.8L.6 2h7l4.8 6.3L18.9 2zm-1.2 18h1.8L7.3 4H5.3l12.4 16z"
                                      })
                                    ], -1)
                                  ]), 8, _hoisted_21))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("button", {
                        class: "text-sm font-medium text-gray-900 border border-gray-300 rounded-full px-4 py-2 hover:bg-gray-100 inline-flex items-center gap-1",
                        type: "button",
                        onClick: ($event: any) => (_ctx.toggleContact(user._id))
                      }, [
                        (!_ctx.isContact(user._id))
                          ? (_openBlock(), _createBlock(_component_UserPlusIcon, {
                              key: 0,
                              class: "h-4 w-4"
                            }))
                          : (_openBlock(), _createBlock(_component_CheckIcon, {
                              key: 1,
                              class: "h-4 w-4"
                            })),
                        _createTextVNode(" " + _toDisplayString(_ctx.isContact(user._id) ? 'Added' : 'Add to Contacts'), 1)
                      ], 8, _hoisted_23),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("a", {
                          class: "text-sm font-medium text-gray-900 inline-flex items-center gap-1 rounded-full bg-primary/20 px-3 py-1.5 hover:bg-primary/30",
                          href: `mailto:${user.email}`
                        }, [
                          _createVNode(_component_EnvelopeIcon, { class: "h-4 w-4 text-gray-900" }),
                          _cache[6] || (_cache[6] = _createTextVNode(" Email "))
                        ], 8, _hoisted_25),
                        (user.phoneNumber)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "text-sm font-medium text-gray-900 inline-flex items-center gap-1 rounded-full bg-primary/20 px-3 py-1.5 hover:bg-primary/30",
                              href: `tel:${user.phoneNumber}`
                            }, [
                              _createVNode(_component_PhoneIcon, { class: "h-4 w-4 text-gray-900" }),
                              _cache[7] || (_cache[7] = _createTextVNode(" Call "))
                            ], 8, _hoisted_26))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, " Joined " + _toDisplayString(_ctx.formatDate(user.createdAt)), 1)
                ]))
              }), 128))
            ]))
    ]),
    _createElementVNode("section", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("h2", _hoisted_30, [
          _createVNode(_component_UserGroupIcon, { class: "h-6 w-6 text-primary" }),
          _cache[8] || (_cache[8] = _createTextVNode(" My Contacts "))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-gray-600 mt-2" }, " Members you have saved for quick access. ", -1))
      ]),
      (_ctx.contactUsers.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, " You have not added any contacts yet. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactUsers, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                key: user._id,
                class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-5"
              }, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.getInitials(user.fullName || user.email)), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_36, _toDisplayString(user.fullName || 'Member'), 1),
                      (user.company)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(user.company), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_EnvelopeIcon, { class: "h-4 w-4 text-gray-400" }),
                          _createTextVNode(" " + _toDisplayString(user.email), 1)
                        ]),
                        (user.phoneNumber)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createVNode(_component_PhoneIcon, { class: "h-4 w-4 text-gray-400" }),
                              _createTextVNode(" " + _toDisplayString(user.phoneNumber), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.formatAddress(user))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.formatAddress(user)), 1))
                        : _createCommentVNode("", true),
                      (user.linkedinUrl || user.xUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            (user.linkedinUrl)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "inline-flex items-center rounded-full bg-gray-100 p-2 text-gray-700 hover:bg-gray-200",
                                  href: user.linkedinUrl,
                                  rel: "noreferrer",
                                  target: "_blank"
                                }, _cache[10] || (_cache[10] = [
                                  _createElementVNode("svg", {
                                    "aria-hidden": "true",
                                    class: "h-4 w-4",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      fill: "currentColor",
                                      d: "M19.99 3H4.01C3.45 3 3 3.45 3 4.01v15.98C3 20.55 3.45 21 4.01 21h15.98c.56 0 1.01-.45 1.01-1.01V4.01C21 3.45 20.55 3 19.99 3zM8.34 18.34H5.67V9.75h2.67v8.59zM7 8.58a1.55 1.55 0 1 1 0-3.1 1.55 1.55 0 0 1 0 3.1zm11.34 9.76h-2.66v-4.18c0-.99-.02-2.27-1.38-2.27-1.38 0-1.59 1.08-1.59 2.2v4.25H10.05V9.75h2.55v1.17h.04c.35-.66 1.2-1.36 2.47-1.36 2.64 0 3.13 1.74 3.13 4.01v4.77z"
                                    })
                                  ], -1)
                                ]), 8, _hoisted_43))
                              : _createCommentVNode("", true),
                            (user.xUrl)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "inline-flex items-center rounded-full bg-gray-100 p-2 text-gray-700 hover:bg-gray-200",
                                  href: user.xUrl,
                                  rel: "noreferrer",
                                  target: "_blank"
                                }, _cache[11] || (_cache[11] = [
                                  _createElementVNode("svg", {
                                    "aria-hidden": "true",
                                    class: "h-4 w-4",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      fill: "currentColor",
                                      d: "M18.9 2h3.3l-7.2 8.2L23.4 22h-6.8l-5.3-7-6.1 7H1.9l7.7-8.8L.6 2h7l4.8 6.3L18.9 2zm-1.2 18h1.8L7.3 4H5.3l12.4 16z"
                                    })
                                  ], -1)
                                ]), 8, _hoisted_44))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("button", {
                      class: "text-sm font-medium text-gray-900 border border-gray-300 rounded-full px-4 py-2 hover:bg-gray-100 inline-flex items-center gap-1",
                      type: "button",
                      onClick: ($event: any) => (_ctx.toggleContact(user._id))
                    }, [
                      _createVNode(_component_CheckIcon, { class: "h-4 w-4" }),
                      _cache[12] || (_cache[12] = _createTextVNode(" Remove "))
                    ], 8, _hoisted_46),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("a", {
                        class: "text-sm font-medium text-gray-900 inline-flex items-center gap-1 rounded-full bg-primary/20 px-3 py-1.5 hover:bg-primary/30",
                        href: `mailto:${user.email}`
                      }, [
                        _createVNode(_component_EnvelopeIcon, { class: "h-4 w-4 text-gray-900" }),
                        _cache[13] || (_cache[13] = _createTextVNode(" Email "))
                      ], 8, _hoisted_48),
                      (user.phoneNumber)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "text-sm font-medium text-gray-900 inline-flex items-center gap-1 rounded-full bg-primary/20 px-3 py-1.5 hover:bg-primary/30",
                            href: `tel:${user.phoneNumber}`
                          }, [
                            _createVNode(_component_PhoneIcon, { class: "h-4 w-4 text-gray-900" }),
                            _cache[14] || (_cache[14] = _createTextVNode(" Call "))
                          ], 8, _hoisted_49))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, " Joined " + _toDisplayString(_ctx.formatDate(user.createdAt)), 1)
              ]))
            }), 128))
          ]))
    ])
  ]))
}